module.exports = __webpack_public_path__ + "images/113_640.jpg";